/**
 * Utility functions for video playback and sound control
 */

import { logDebug } from './logger';

/**
 * Toggle sound on a video element
 * @param {Object} videoRef - Ref to the video element
 * @param {Object} isMutedRef - Ref to the muted state boolean
 */
export const toggleVideoSound = (videoRef, isMutedRef) => {
  logDebug('toggleVideoSound called');
  if (videoRef.value) {
    logDebug('Video element found');
    isMutedRef.value = !isMutedRef.value;
    videoRef.value.muted = isMutedRef.value;
    logDebug(`Sound toggled, now ${isMutedRef.value ? 'muted' : 'unmuted'}`);

    // When unmuting, also ensure the video plays
    if (!isMutedRef.value) {
      logDebug('Attempting to play video');
      try {
        const playPromise = videoRef.value.play();
        if (playPromise) {
          playPromise.catch((error) => {
            logDebug('Play promise rejected:', error);
          });
        }
      } catch (error) {
        logDebug('Play error:', error);
      }
    }
  }
};
